import React, { useState } from 'react';
import ProfileCard from './ProfileCard';
import SwipeButtons from './SwipeButtons';
import DilSwipeModeSelect from './DilSwipeModeSelect';
import { DIL_SWIPE_MODES } from './dilSwipeModes';

export default function CardStack({ profiles: initialProfiles = [] }) {
  const [profiles, setProfiles] = useState(initialProfiles);
  const [hasSwiped, setHasSwiped] = useState(false);
  const [mode, setMode] = useState(DIL_SWIPE_MODES.DATING);

  // TOP card = LAST item (important for touch + z-index)
  const topIndex = profiles.length - 1;
  const topProfile = profiles[topIndex];
  const nextProfile = profiles[topIndex - 1];

  const removeTopProfile = () => {
    setHasSwiped(true);
    setTimeout(() => {
      setProfiles((prev) => prev.slice(0, -1));
    }, 450);
  };

  const handleSwipe = (direction) => {
    if (!topProfile) return;
    // console.log(`Swiped ${direction} on ${topProfile.name}`);
    removeTopProfile();
  };

  const handleDoubleTap = () => {
    if (!topProfile) return;
    // console.log(`Double tapped ${topProfile.name}`);
    removeTopProfile();
  };

  if (!topProfile) {
    return (
      <div className="text-center text-gray-500 py-20 px-4">
        No more profiles nearby 😔<br />
        Check back later!
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="absolute top-2 left-1/2 z-50 transform -translate-x-1/2 -translate-y-2">
        <DilSwipeModeSelect mode={mode} setMode={setMode} />
      </div>

      <div className="relative flex-1 w-full aspect-[3/4] max-w-sm mx-auto">

        {/* Next card (background) */}
        {nextProfile && (
          <ProfileCard
            profile={nextProfile}
            mode={mode}
            isTopCard={false}
            className="scale-95 opacity-70 translate-y-4 z-10"
          />
        )}

        {/* Top swipeable card */}
        <ProfileCard
          profile={topProfile}
          mode={mode}
          isTopCard
          onSwipe={handleSwipe}
          onDoubleTap={handleDoubleTap}
          className="z-20"
        />
      </div>

      {/* Desktop buttons */}
      <div className="hidden md:flex justify-center gap-12 mt-6 pb-6">
        <SwipeButtons
          onSwipeLeft={() => handleSwipe('left')}
          onSwipeRight={() => handleSwipe('right')}
        />
      </div>

      {/* Mobile swipe hint — RESTORED */}
      <div
        className={`
          md:hidden transition-all duration-500 ease-out
          ${hasSwiped ? 'opacity-0 h-0 py-0' : 'opacity-100 h-auto py-4'}
        `}
      >
        <div className="flex justify-between items-center px-8 text-gray-400 text-sm">
          <div className="flex flex-col items-center">
            <span className="text-2xl">←</span>
            <span>Nope</span>
          </div>
          <div className="text-xs text-center opacity-70">
            Swipe or double-tap
          </div>
          <div className="flex flex-col items-center">
            <span className="text-2xl">→</span>
            <span>Like</span>
          </div>
        </div>
      </div>
    </div>
  );
}
